export default __webpack_public_path__ + "static/media/active_team_ico.e4e06f0d.svg";